'use client';

interface FooterProps {
  showFooter: boolean;
}

export const Footer = (props: FooterProps) => {
  const year = new Date().getFullYear();

  return (
    props.showFooter && (
      <div className='bg-crystal w-full h-[64px] flex items-center justify-center py-10 mt-auto'>
        <p className='font-nunito font-bold text-[12px] md:text-[14px] text-water'>
          © 2014-{year} Leiturinha, uma empresa do Grupo Sandbox
        </p>
      </div>
    )
  );
};

export default Footer as React.FC<FooterProps>;
